export interface SystemConfigEntry {
  key: string;
  value: unknown;
}

export function unwrapConfigValue(value: unknown): unknown {
  if (value === null || value === undefined) return value;
  if (
    typeof value === 'object' &&
    !Array.isArray(value) &&
    'value' in (value as Record<string, unknown>)
  ) {
    return (value as Record<string, unknown>).value;
  }
  return value;
}

export function isConfigEnabled(value: unknown): boolean {
  const raw = unwrapConfigValue(value);
  if (typeof raw === 'boolean') return raw;
  if (typeof raw === 'string') return raw.toLowerCase() === 'true';
  if (typeof raw === 'number') return raw !== 0;
  return false;
}

export function getDisabledAppKeys(configs: SystemConfigEntry[]): string[] {
  return configs
    .filter(config => config.key.startsWith('app_enabled:'))
    .filter(config => !isConfigEnabled(config.value))
    .map(config => config.key.replace('app_enabled:', ''));
}

export function getInstalledModules(configs: SystemConfigEntry[]): string[] | null {
  const config = configs.find(c => c.key === 'system.installed_modules');
  if (!config) return null;
  const raw = unwrapConfigValue(config.value);
  if (Array.isArray(raw)) return raw as string[];
  return null;
}

export function filterAppsBySystemConfig(
  roleApps: string[],
  configs: SystemConfigEntry[],
): string[] {
  const disabled = new Set(getDisabledAppKeys(configs));
  let filtered = roleApps.filter(app => !disabled.has(app));

  const installed = getInstalledModules(configs);
  if (installed) {
    const installedSet = new Set(installed);
    filtered = filtered.filter(app => installedSet.has(app));
  }

  return filtered;
}

export function getConfigString(configs: SystemConfigEntry[], key: string): string {
  const config = configs.find(entry => entry.key === key);
  if (!config) return '';
  const raw = unwrapConfigValue(config.value);
  if (typeof raw !== 'string') return '';
  return raw.trim();
}
